import React from 'react'
import { getCommonStyles } from '@utils'
import { GhostPresentationSection } from './GhostPresentationSection'
import {
  AboutSection,
  AvailabilitySection,
  ContactItem,
  ProfileSection,
} from '../../../profile/components'
import { useTheme } from '@react-navigation/native'
import { View } from 'react-native'
import { Profile, useScreen } from '@hooks'
import { About as AboutMobile } from './About.tsx'
import { days } from '@components'
import { useLanguage } from '@context'

export const About = ({ profile }: { profile?: Profile }) => {
  const { isMobile } = useScreen()
  const theme = useTheme()
  const { t } = useLanguage()

  if (isMobile) return <AboutMobile profile={profile} />

  const commonStyles = getCommonStyles(theme)
  // Transformer les données pour les contacts
  const contactItems: ContactItem[] = [
    {
      type: 'mail' as const,
      label: t('ghostProfile.email'),
      value: profile?.contacts?.email || '',
      iconName: 'message' as const,
    },
    {
      type: 'website' as const,
      label: t('ghostProfile.website'),
      value: profile?.contacts?.website || '',
      iconName: 'link2' as const,
    },
    {
      type: 'phone' as const,
      label: t('ghostProfile.phone'),
      value: profile?.contacts?.phone || '',
      iconName: 'phone' as const,
    },
  ]

  const aboutCategories = [
    {
      title: t('ghostProfile.hashtags'),
      content: '',
      tags: profile?.hashtags || [],
    },
    {
      title: t('ghostProfile.objectives'),
      content: '',
      tags: profile?.goals || [],
    },
    {
      title: t('ghostProfile.hobby'),
      content: '',
      tags: profile?.hobbies || [],
    },
    {
      title: t('ghostProfile.skills'),
      content: '',
      tags: profile?.skills || [],
    },
  ]

  return (
    <View style={[commonStyles.row, commonStyles.alignStart]}>
      <View style={commonStyles.flex}>
        <GhostPresentationSection
          birthday={profile?.birthDate}
          languages={profile?.languages}
          nationalities={profile?.nationalities}
          origins={profile?.origins}
        />

        <ProfileSection
          title={t('ghostProfile.livedPlaces')}
          sectionType="places"
          items={
            profile?.residenceHistory?.map((residence) => ({
              id: residence.code,
              name: residence.name,
            })) || []
          }
          noEdit
        />
      </View>
      <View style={commonStyles.flex}>
        <ProfileSection
          title={t('ghostProfile.contactInfo')}
          noEdit
          sectionType="contacts"
          items={contactItems}
        />
        <AvailabilitySection
          title={t('ghostProfile.availabilities')}
          noEdit
          disponibilities={
            profile?.availabilities?.slots?.map((slot) => ({
              dayStart: days.find((day) => day.id === slot.days[0].toString())!,
              dayEnd: days.find((day) => day.id === slot.days[slot.days.length - 1].toString())!,
              timeStart: slot.from,
              timeEnd: slot.to,
            })) || []
          }
          bestMoments={profile?.availabilities?.moments || []}
        />
      </View>
      <View style={commonStyles.flex}>
        <AboutSection title={t('ghostProfile.categories')} noEdit categories={aboutCategories} />
      </View>
    </View>
  )
}
